import { ReactNode } from 'react';
import { useLang } from 'hooks/lang';

import { IconButton, Row, ShortcutTag, SideSheet } from 'components/Blocks';
import { KeyboardIcon } from 'components/Icons';

import { useMultiKeyPress } from 'hooks';

import { AnyFunction } from 'types';

interface ShortcutProps {
  tabs: Array<{ value: string; label: string; icon: ReactNode }>;
  action: (value: string) => void;
}

function SingleShortcut({ action, shortcutKey }: { action: AnyFunction; shortcutKey: string }) {
  useMultiKeyPress({
    key: shortcutKey,
    triggerKey: 'ctrl',
    action,
  });

  return <></>;
}

export function StatusTabShortcuts({ action, tabs }: ShortcutProps) {
  const { t } = useLang();

  return (
    <>
      {tabs.map(({ value }, index) => (
        <SingleShortcut key={value} shortcutKey={`${index + 1}`} action={() => action(value)} />
      ))}

      <SideSheet
        title="Shortcuts"
        description={t('status-tab-shortcut-desc')}
        trigger={
          <IconButton tooltipContent="Shortcuts..." className="small_tablet:hidden">
            <KeyboardIcon />
          </IconButton>
        }
      >
        {tabs.map(({ label, value, icon }, index) => (
          <Row key={value}>
            {icon}
            <p>{label}</p>
            <ShortcutTag keys={['ctrl', `${index + 1}`]} />
          </Row>
        ))}
      </SideSheet>
    </>
  );
}
